import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Col, Container, Form } from "react-bootstrap";
import { loginUser } from "actions/authActions";
import Spinner from "components/common/Spinner";

class Login extends React.Component {
    constructor() {
        super();
        this.state = {
            employeeCode: "",
            password: "",
            validated: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            this.setState({
                validated: true
            });
        } else {
            const {
                employeeCode,
                password
            } = this.state;
            this.props.loginUser({
                employeeCode,
                password
            });
        }
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const {
            validated
        } = this.state;

        return (
            <Container>
                <div>
                    <Col md={8} className="m-auto">
                        <h1 className="display-4 text-center">Log In</h1>
                        <p className="lead text-center">
                            Sign in to your account
                        </p>
                        <Form
                            noValidate
                            validated={validated}
                            onSubmit={e => this.onSubmit(e)}
                            className="position-relative"
                        >
                            {!this.props.loading || <Spinner/>}
                            <Form.Group as={Col} controlId="validationCustomEmail">
                                <Form.Label>Login Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Login Code"
                                    name="employeeCode"
                                    autoComplete="username"
                                    value={this.state.employeeCode}
                                    onChange={this.onChange}
                                    aria-describedby="inputGroupPrepend"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please input login code.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} controlId="validationCustomPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    placeholder="Password"
                                    autoComplete="current-password"
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.onChange}
                                    aria-describedby="inputGroupPrepend"
                                    required
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please input password.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <div className="d-flex justify-content-between col">
                                <Link
                                    to="/loginCustomer"
                                    className=""
                                >
                                    <Button className="btn btn-warning">
                                        Login as customer
                                    </Button>
                                </Link>
                                <Button type="submit">Login</Button>
                            </div>
                        </Form>
                    </Col>
                </div>
            </Container>
        );
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    loading: state.globalFormErrors.loading
});

const mapStateToDispatch = dispatch => ({
    loginUser: bindActionCreators(loginUser, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Login);
